import { Typography } from '@aloft/toolkit-sui';

import { selectPropertyIdentificationById } from '../../../redux/features/selectors/propertyDataSelectors/propertyIdentificationSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { proximityMiles } from '../../../utils/proximityMiles.ts';

type Props = {
  propertyId: string;
};

export const ValuationTablePropertyHeaderDistanceToSubject = ({ propertyId }: Props) => {
  if (propertyId === 'subject' || propertyId === 'subjectArv') return null;

  const subjectPropertyIdentification = useAppSelector((state) =>
    selectPropertyIdentificationById(state, 'subject'),
  );
  const propertyIdentification = useAppSelector((state) =>
    selectPropertyIdentificationById(state, propertyId),
  );

  const { coordinates: subjectCoordinates } = subjectPropertyIdentification || {};
  const { coordinates: propertyCoordinates } = propertyIdentification || {};

  if (!subjectCoordinates || !propertyCoordinates) return null;

  const proximityToSubject = proximityMiles(subjectCoordinates, propertyCoordinates);

  if (proximityToSubject === undefined) return null;

  return (
    <Typography variant="h3" color="textTertiary">
      {`(${proximityToSubject.toFixed(2)} mi)`}
    </Typography>
  );
};
